__webpack_require__.p = "/ravelry-rando/";